export const petsPeriodLabels = {
  '6m': '6 місяців',
  '9m': '9 місяців',
  '12m': '12 місяців',
};